export default __webpack_public_path__ + "static/media/call-now-without-arrow.cc924eee.svg";